<template>
  <div class="subscribe-newsletter">
    <div class="max-width">
      <div class="subscribe-newsletter__grid">
        <div class="subscribe-newsletter__about">
          <h2 class="subscribe-newsletter__title">Be the First to Know</h2>
          <div class="subscribe-newsletter__note">New theme releases, performance updates, store growth guides, and curated industry resources — delivered to your inbox before everyone else.</div>

          <SubformDarkView :theme="theme"/>
        </div>
        <div class="subscribe-newsletter__img">
          <img loading="lazy" src="@/assets/imgs/newsletter.webp" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .subscribe-newsletter {
    padding:5.625rem 0;
    background:#fff;

    @include sm {
      padding:3.5rem 0;
    }

    &__grid {
      display:flex;
      align-items:center;
      gap:2rem;

      @include md {
        flex-direction:column-reverse;
        gap:1rem;
      }
    }

    &__about {
      max-width:450px;
      width:100%;
      flex:none;

      @include md {
        max-width:100%;
      }
    }

    &__title {
      font-weight: 900;
      font-size: 2.5rem;
      line-height: 1.2;
      letter-spacing: -0.03em;
      margin:0 0 1rem;

      @include sm {
        font-size:2rem;
      }
    }

    &__note {
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.5;
      letter-spacing: -0.01em;
      margin:0 0 1.5rem;
      opacity:.7;

      @include sm {
        font-size:.875rem;
      }
    }

    .subscribe-form {

    }

    &__img {
      flex:auto;
    }
  }

  body:has(.help) .subscribe-newsletter {
    margin-top:7.5rem;

    @include sm {
      margin-top:3.5rem;
    }
  }
</style>

<script setup>
import IconArrow from '@/components/icons/IconArrow.vue'
import SubformDarkView from "@/components/SubformDarkView.vue";
import SubformView from "@/components/SubformView.vue";

const props = defineProps({
  theme: {
    type: String,
    default: ''
  }
})
</script>
